import { render, staticRenderFns } from "./RiskQuotationStatusHistory.vue?vue&type=template&id=14eac4f0&scoped=true&"
import script from "./RiskQuotationStatusHistory.vue?vue&type=script&lang=js&"
export * from "./RiskQuotationStatusHistory.vue?vue&type=script&lang=js&"
import style0 from "./RiskQuotationStatusHistory.vue?vue&type=style&index=0&id=14eac4f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14eac4f0",
  null
  
)

export default component.exports